export const carousel = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  content: {
    gap: "{gap.4}",
  },
  indicatorList: {
    padding: "{pading.16}",
    gap: "{gap.8}",
  },
  indicator: {
    width: "2rem",
    height: "0.5rem",
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}",
    },
  },
  colorScheme: {
    light: {
      indicator: {
        background: "{surface.bg-grey}",
        hoverBackground: "{surface.bg-grey-contrast}",
        activeBackground: "{surface.bg-grey-contrast}",
      },
    },
    dark: {
      indicator: {
        background: "{surface.bg-grey}",
        hoverBackground: "{surface.bg-grey-contrast}",
        activeBackground: "{surface.bg-grey-contrast}",
      },
    },
  },
};
